import { createSelector } from 'reselect';

const selectDBNCategoryProductMappings = (state: any) => state.dbnCategoryProductMappings;


export const selectDBNCategoryProductMappingsCurrentItem = createSelector([selectDBNCategoryProductMappings], (dbnCategoryProductMappings) => dbnCategoryProductMappings.current);

export const selectDBNCategoryProductMappingsListItems = createSelector([selectDBNCategoryProductMappings], (dbnCategoryProductMappings) => dbnCategoryProductMappings.list);

export const selectDBNCategoryProductMappingsItemById = (itemId: any) =>
    createSelector(selectDBNCategoryProductMappingsListItems, (list) => list.result.items.find((item: any) => item._id === itemId));

export const selectDBNCategoryProductMappingsQueryItems = createSelector([selectDBNCategoryProductMappings], (dbnCategoryProductMappings) => dbnCategoryProductMappings.query);

export const selectDBNCategoryProductMappingsCreatedItem = createSelector([selectDBNCategoryProductMappings], (dbnCategoryProductMappings) => dbnCategoryProductMappings.create);

export const selectDBNCategoryProductMappingsUpdatedItem = createSelector([selectDBNCategoryProductMappings], (dbnCategoryProductMappings) => dbnCategoryProductMappings.update);

export const selectDBNCategoryProductMappingsReadItem = createSelector([selectDBNCategoryProductMappings], (dbnCategoryProductMappings) => dbnCategoryProductMappings.read);

export const selectDBNCategoryProductMappingsDeletedItem = createSelector([selectDBNCategoryProductMappings], (dbnCategoryProductMappings) => dbnCategoryProductMappings.delete);

export const selectDBNCategoryProductMappingsearchedItems = createSelector([selectDBNCategoryProductMappings], (dbnCategoryProductMappings) => dbnCategoryProductMappings.search);

export const selectDBNCategoryProductMappingsItemsCount = createSelector([selectDBNCategoryProductMappings], (dbnCategoryProductMappings) => dbnCategoryProductMappings.count);

export const selectDBNCategoryProductMappingsItemsFilter = createSelector([selectDBNCategoryProductMappings], (dbnCategoryProductMappings) => dbnCategoryProductMappings.filter);